import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MotivationViewComponent } from './components/motivation-view/motivation-view.component';
import { WindowReferenceModule } from './modules/window-reference';
import { ExpansionTextComponent } from './components/expansion-text/expansion-text.component';
import { BaseComponent } from './base/base.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconBkgComponent } from './components/mat-icon-bkg/mat-icon-bkg.component';
import {MatIconModule} from '@angular/material/icon';
import { ClaroLabelComponent } from './components/claro-label/claro-label.component';
import { ClaroStarRatingComponent } from './components/claro-star-rating/claro-star-rating.component';
import { MoovViewComponent } from './components/moov-view/moov-view/moov-view.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { CarouselItemDirective } from '../carousel/directives/carousel-item/carousel-item.directive';
import { CarouselItemElement } from '../carousel/directives/carousel-item-element/carousel-item-element.directive';
import { CarouselComponent } from '../carousel/carousel.component';
import { SendFeedbackComponent } from './components/send-feedback/send-feedback/send-feedback.component';
import { ClaroIconComponent } from './components/claro-icon/claro-icon.component';
import { ClaroBigLabelComponent } from './components/claro-big-label/claro-big-label.component';
import { GenderPipe } from './pipes/gender.pipe';
import { TranslateByGenderPipe } from './pipes/translate-gender.pipe';
import { MotivationPartialViewComponent } from './components/motivation-partial-view/motivation-partial-view/motivation-partial-view.component';
import { UserMessageComponent } from './components/user-message/user-message/user-message.component';
import { MiniMoovViewComponent } from './components/moov-view/mini-moov-view/mini-moov-view.component';
import { AutofocusDirective } from './directives/autofocus/autofocus.directive';
import { ClaroIconMatIconComponent } from './components/claro-icon-mat-icon/claro-icon-mat-icon.component';
import { TimelineComponent } from './components/timeline/timeline/timeline.component';
import { MoovStepComponent } from './components/moov-view/moov-step/moov-step.component';
import { ManagedUserCommentComponent } from './components/managed-user-comment/managed-user-comment.component';
import { ScoreComponent } from './components/score/score/score.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { MotivationTrendComponent } from './components/motivation-trend/motivation-trend/motivation-trend.component';
import { QuickActionsComponent } from './components/quick-actions/quick-actions/quick-actions.component';
import { MoovPeekComponent } from './components/moov-view/moov-peek/moov-peek.component';
import { MotivationTicketComponent } from './components/motivation-ticket/motivation-ticket/motivation-ticket.component';
import { TrendTextComponent } from './components/trend-text/trend-text/trend-text.component';
import { ClaroAlertComponent } from './components/claro-alert/claro-alert.component';
import { ClaroImageButtonComponent } from './components/claro-image-button/claro-image-button.component';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import {MatChipsModule} from '@angular/material/chips';
import { ClaroComplexMessageComponent } from './components/claro-complex-message/claro-complex-message.component';
import { TeamMemberCardComponent } from './components/team-member-card/team-member-card.component';
import { ClaroTagComponent } from './components/claro-tag/claro-tag.component';
import { DriverLevelComponent } from './components/driver-level/driver-level.component';
import { ClaroMiniImageButtonComponent } from './components/claro-mini-image-button/claro-mini-image-button.component';
import { ClaroProgressBarComponent } from './components/claro-progress-bar/claro-progress-bar.component';
import { StepProgressBarComponent } from './components/step-progress-bar/step-progress-bar.component';
import { DigitsInputComponent } from './components/digits-input/digits-input.component';
import { ClaroTooltipIconComponent } from './components/claro-tooltip-icon/claro-tooltip-icon.component';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { SelectUsersFromListComponent } from './components/select-users-from-list/select-users-from-list.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ActionConfirmationDialogComponent } from './components/action-confirmation-dialog/action-confirmation-dialog.component';
import { DriverEnergySliderComponent } from './components/driver-energy-slider/driver-energy-slider.component';
import { HorizontalScaleSliderComponent } from './components/horizontal-scale-slider/horizontal-scale-slider.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { StartNewQuestDialogComponent } from './components/start-new-quest-dialog/start-new-quest-dialog.component';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';

@NgModule({
  declarations: [
    MotivationViewComponent,
    ExpansionTextComponent,
    MatIconBkgComponent,
    BaseComponent,
    ClaroLabelComponent,
    ClaroStarRatingComponent,
    MoovViewComponent,
    CarouselComponent,
    CarouselItemDirective,
    CarouselItemElement,
    SendFeedbackComponent,
    ClaroIconComponent,
    ClaroBigLabelComponent,
    GenderPipe,
    TranslateByGenderPipe,
    MotivationPartialViewComponent,
    UserMessageComponent,
    MiniMoovViewComponent,
    AutofocusDirective,
    ClaroIconMatIconComponent,
    TimelineComponent,
    MoovStepComponent,
    ManagedUserCommentComponent,
    ScoreComponent,
    MotivationTrendComponent,
    QuickActionsComponent,
    MoovPeekComponent,
    MotivationTicketComponent,
    TrendTextComponent,
    ClaroAlertComponent,
    ClaroImageButtonComponent,
    ClaroComplexMessageComponent,
    TeamMemberCardComponent,
    ClaroTagComponent,
    DriverLevelComponent,
    ClaroMiniImageButtonComponent,
    ClaroProgressBarComponent,
    StepProgressBarComponent,
    DigitsInputComponent,
    ClaroTooltipIconComponent,
    SafeUrlPipe,
    SelectUsersFromListComponent,
    ActionConfirmationDialogComponent,
    DriverEnergySliderComponent,
    HorizontalScaleSliderComponent,
    ConfirmationDialogComponent,
    StartNewQuestDialogComponent,
    ProgressBarComponent

  ],
  imports: [
    NgApexchartsModule,
    CommonModule,
    WindowReferenceModule,
    MatIconModule,
    MatButtonModule,
    MatTabsModule,
    MatInputModule,
    FormsModule,
    MatListModule,
    MatDividerModule,
    MatListModule,
    TranslateModule,
    MatSlideToggleModule,
    MatProgressBarModule, 
    MatChipsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatProgressSpinnerModule
  ],
  exports: [
    MotivationViewComponent,
    MatIconBkgComponent,
    TranslateModule,
    ClaroLabelComponent,
    ClaroStarRatingComponent,
    MoovViewComponent,
    CarouselComponent,
    CarouselItemDirective,
    CarouselItemElement,
    SendFeedbackComponent,
    ClaroIconComponent,
    ClaroIconMatIconComponent,
    ClaroBigLabelComponent,
    GenderPipe,
    TranslateByGenderPipe,
    MiniMoovViewComponent,
    ScoreComponent,
    MotivationTrendComponent,
    MotivationTicketComponent,
    QuickActionsComponent,
    MoovPeekComponent,
    TrendTextComponent,
    ClaroAlertComponent,
    ClaroImageButtonComponent,
    ClaroComplexMessageComponent,
    TeamMemberCardComponent,
    ClaroTagComponent,
    DriverLevelComponent,
    ClaroProgressBarComponent,
    StepProgressBarComponent,
    DigitsInputComponent,
    ClaroTooltipIconComponent,
    DriverEnergySliderComponent,
    HorizontalScaleSliderComponent,
    ProgressBarComponent
  ],
  providers:[
    DatePipe
  ]
})
export class MoovCommonModule { }
